<div
  id="admin-sidebar"
  class="fixed inset-y-0 start-0 z-[60] flex h-full w-[300px] max-h-full transform flex-col border-e border-slate-200 bg-slate-100 text-slate-700 transition-all duration-300 ease-in-out lg:translate-x-0"
  [ngClass]="{
    'translate-x-0': isOpen(),
    '-translate-x-full': !isOpen(),
    'lg:w-16': !isOpen(),
  }"
  role="dialog"
  tabindex="-1"
  aria-label="Sidebar"
  [attr.aria-hidden]="ariaHidden()"
>
  <div class="relative flex h-full max-h-full flex-col">
    <div
      class="flex h-[50px] shrink-0 items-center justify-between border-b border-slate-300/60 px-4"
      [ngClass]="{ 'lg:justify-center lg:px-0': !isOpen() }"
    >
      <a
        routerLink="/dashboard"
        class="inline-block flex-none focus:outline-hidden focus:opacity-80"
        aria-label="DenunciaNR1"
      >
        @if (isOpen()) {
          <p class="text-lg font-bold leading-none tracking-tight">
            <span class="text-blue-600">Denuncia</span><span class="text-slate-900">NR1</span>
          </p>
          <p class="mt-0.5 text-[0.5rem] font-medium uppercase leading-none tracking-[0.24em] text-slate-500">
            By OneFactory
          </p>
        } @else {
          <p class="hidden text-lg font-bold leading-none lg:block">
            <span class="text-blue-600">D</span><span class="text-slate-900">N</span>
          </p>
        }
      </a>

      <button
        type="button"
        class="inline-flex size-5 items-center justify-center rounded border border-transparent text-slate-500 hover:bg-slate-200 focus:bg-slate-200 focus:outline-hidden lg:hidden"
        (click)="handleCloseSidebar()"
        aria-label="Fechar sidebar"
      >
        <span class="sr-only">Fechar sidebar</span>
        <app-bootstrap-icon name="x-lg" sizeClass="text-base" colorClass="text-current" />
      </button>
    </div>

    <div
      class="min-h-0 flex-1 overflow-y-auto [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-track]:bg-slate-100 [&::-webkit-scrollbar]:w-2"
    >
      <nav class="flex w-full flex-col p-3" [ngClass]="{ 'lg:px-2': !isOpen() }">
        @for (section of navSections(); track section.id) {
          <div class="mb-5 last:mb-0" [ngClass]="{ 'lg:mb-3': !isOpen() }">
            <p
              class="mb-2 px-2.5 text-xs font-semibold uppercase tracking-wider text-slate-400"
              [class.lg:hidden]="!isOpen()"
            >
              {{ section.label }}
            </p>
            <ul class="flex flex-col space-y-2">
              @for (item of section.items; track item.path) {
                <li>
                  <a
                    [routerLink]="item.path"
                    routerLinkActive
                    #navLink="routerLinkActive"
                    [routerLinkActiveOptions]="routerLinkActiveOptions(item.path)"
                    [attr.title]="!isOpen() ? item.label : null"
                    class="flex items-center gap-x-3 rounded px-2.5 py-2 text-sm transition-colors hover:bg-slate-200/60 focus:bg-slate-200/60"
                    [ngClass]="{ 'lg:justify-center lg:px-0 lg:gap-x-0': !isOpen() }"
                    [class.font-normal]="!navLink.isActive"
                    [class.text-slate-500]="!navLink.isActive"
                    [class.bg-slate-200/60]="navLink.isActive"
                    [class.font-semibold]="navLink.isActive"
                    [class.text-blue-600]="navLink.isActive"
                  >
                    <app-bootstrap-icon [name]="item.icon" sizeClass="text-base" colorClass="text-current" />
                    <span class="line-clamp-1" [class.lg:hidden]="!isOpen()">{{ item.label }}</span>
                  </a>
                </li>
              }
            </ul>
          </div>
        }
      </nav>
    </div>

    <div class="shrink-0 border-t border-slate-300/60 px-4 py-3" [class.lg:hidden]="!isOpen()">
      <p
        class="text-[0.6875rem] leading-relaxed text-slate-500 transition-opacity duration-200"
        [class.opacity-0]="!footerTextVisible()"
        [class.opacity-100]="footerTextVisible()"
      >
        © 2026 OneFactory. Todos os direitos reservados.
      </p>
    </div>
  </div>
</div>
